"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = edit;
exports.destroy = destroy;

var _request = _interopRequireDefault(require("@/utils/request"));

function edit(data) {
  return (0, _request.default)({
    url: '/cat-tags/edit',
    method: 'post',
    data: data
  });
}

function destroy(id) {
  return (0, _request.default)({
    url: "/cat-tags/".concat(id),
    method: 'delete'
  });
} // export function getCatTagsList() {
//   return {catTagsList: [
//         {
//           value: 1,
//           label: '英短'
//         }, {
//           value: 2,
//           label: '英长'
//         }, {
//           value: 3,
//           label: '美短'
//         }, {
//           value: 4,
//           label: '美长'
//         }, {
//           value: 5,
//           label: '布偶'
//         }, {
//           value: 6,
//           label: '金吉拉'
//         }, {
//           value: 7,
//           label: '缅因'
//         }, {
//           value: 8,
//           label: '暹罗'
//         }, {
//           value: 9,
//           label: '曼基康矮脚'
//         }, {
//           value: 10,
//           label: '异瞳'
//         }, {
//           value: 11,
//           label: '八字脸'
//         }, {
//           value: 12,
//           label: '五粉'
//         }
//   ]}
// }